import { Box, useMediaQuery } from "@mui/material";
import { Show, SimpleShowLayout, useRecordContext } from "react-admin";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";
import BackButtonToolbar from "features/BackButtonToolbar";
import InfoSection from "./InfoSection";
import { CurriculumContext } from "./CurriculumContext";
import { collections } from "./collections/registry";
// Swap this import for ./layouts/SectionsLayout to render every collection stacked instead.
import Layout from "./layouts/WorkbenchLayout";

const CurriculumContent = () => {
  const curriculum = useRecordContext();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  if (!curriculum) return null;

  return (
    <CurriculumContext.Provider value={curriculum}>
      <SectionTitle
        paddingY={2}
        title="Основна информация"
        textAlign="center"
      />
      <Box sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}>
        <InfoSection />
      </Box>

      <Layout
        collections={collections}
        curriculum={curriculum}
      />
    </CurriculumContext.Provider>
  );
};

const ShowCurriculum = () => (
  <Show
    title="Детайли за учебен план"
    actions={<BackButtonToolbar />}
  >
    <SimpleShowLayout>
      <CurriculumContent />
    </SimpleShowLayout>
  </Show>
);

export default ShowCurriculum;
